import { QueryClientProvider } from '@tanstack/react-query';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { Layout } from '@frontend/components/layout/Layout';
import { Toaster } from '@frontend/components/ui/toaster';
import { QUERY_CLIENT } from '@frontend/const/const.QUERY_CLIENT';
import { AuthGuard } from '@frontend/features/auth/components/AuthGuard';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <QueryClientProvider client={QUERY_CLIENT}>
      <AuthGuard>
        <Layout>
          <Outlet />
        </Layout>
      </AuthGuard>
      <Toaster />
      <TanStackRouterDevtools position="bottom-right" />
    </QueryClientProvider>
  );
}
